import api from '../../plugins/api';

const createMark = (params) => {
  return api.post('/api/crm/cars/createMark', params);
};

export default createMark;
